import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable, LOCALE_ID, inject } from '@angular/core';
import { LOCALE } from '@univacity/shared/types';
import { Observable } from 'rxjs';

@Injectable()
export class LocaleInterceptor implements HttpInterceptor {
  private readonly locale = inject(LOCALE_ID);

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(this.addCredential(request));
  }

  addCredential(request: HttpRequest<any>) {
    const locale = Object.values(LOCALE).includes(this.locale as LOCALE)
      ? this.locale
      : LOCALE.english;
    return request.clone({
      setParams: { locale: request.params.get('locale') || locale },
    });
  }
}
